import ConfirmModal from "components/ConfirmModal";
import { ModalProps } from "components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import MakeContactModal from "./MakeContactModal";

const FileUploadDisabledAlert = (props: ModalProps) => {
  const { t } = useTranslation();
  const [openContactForm, setOpenContactForm] = React.useState(false);

  if (openContactForm) {
    return (
      <MakeContactModal
        open={openContactForm}
        close={() => setOpenContactForm(false)}
      />
    );
  }

  return (
    <ConfirmModal
      open={props.open}
      close={props.close}
      type="info"
      title={t("dashboard.acquireCircularLcaLicence")}
      containerClassName="sm:my-8 sm:max-w-sm sm:w-full md:max-w-xl"
      descriptionMesage={t("dashboard.fileUploadsDisabled")}
      confirmButtonTitle={t("dashboard.makeContact")}
      onConfirm={() => setOpenContactForm(true)}
      hideCancel
    ></ConfirmModal>
  );
};

export default FileUploadDisabledAlert;
